/**
 * Gutters
 */
	const siteGutters = () => {
		const siteFooter = document.querySelector('footer')
		const siteHeader = document.querySelector('header')

		if (siteFooter) document.documentElement.style.setProperty('--footer-offset', `${siteFooter.offsetHeight}px`)
		if (siteHeader) document.documentElement.style.setProperty('--header-offset', `${siteHeader.offsetHeight}px`)
	}

	window.addEventListener('load', _ => {
		siteGutters()
	})

	window.addEventListener('resize', _ => {
		setTimeout(() => {
			siteGutters()
		}, 100);
	})
